import { CognitoUserAttribute } from 'amazon-cognito-identity-js'

export interface UserAttributes {
  sub: string
  email: string
  given_name: string
  family_name: string
  email_verified: string
  organization_id: string
  organization_name: string
}

export const convertUserAttributesListToLabels = (attributes: CognitoUserAttribute[]): UserAttributes =>
  attributes.reduce(
    (obj, item) =>
      Object.assign(obj, {
        [item.Name === 'custom:organization_id'
          ? 'organization_id'
          : item.Name === 'custom:organization_name'
          ? 'organization_name'
          : item.Name]: item.Value
      }),
    {} as UserAttributes
  )
